export const sanitizeColonSeperatedEmail = (email: string) => {
    if (!email || email === '') return null;

    let uptEmail = email.replaceAll(",", ";").replaceAll(" ", "").replaceAll(";;", ";");
    if (!uptEmail || uptEmail === "") return null;

    if (uptEmail.startsWith(";"))
        uptEmail = uptEmail.slice(1);
    if (uptEmail.endsWith(";"))
        uptEmail = uptEmail.slice(0, uptEmail.length - 1);

    if (!uptEmail || uptEmail === "") return null;

    return uptEmail;
}


export const validateEmail = (email: string) => {
    var mailformat = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return mailformat.test(email.toLowerCase());
}